// Éléments graphiques vectoriels (légers, nets sur tous les écrans).

export function MountainMark({ className = 'mountain' }) {
  return (
    <svg className={className} viewBox="0 0 64 34" aria-hidden="true">
      <path d="M2 32 L22 8 L30 17 L40 4 L62 32 Z" fill="currentColor" opacity="0.95" />
      <path d="M22 8 L27 14 L24 13 L21 16 L18 13 Z M40 4 L46 12 L42 11 L39 14 L35 10 Z"
            fill="#fff" opacity="0.9" />
    </svg>
  );
}

export function Puck() {
  return (
    <svg className="puck-svg" viewBox="0 0 100 100" aria-hidden="true">
      <defs>
        <radialGradient id="pk-face" cx="38%" cy="32%" r="75%">
          <stop offset="0" stopColor="#ffffff" />
          <stop offset="0.55" stopColor="#e9eef5" />
          <stop offset="1" stopColor="#b9c4d3" />
        </radialGradient>
        <linearGradient id="pk-rim" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="var(--brand-2)" />
          <stop offset="1" stopColor="var(--brand-0)" />
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="47" fill="url(#pk-rim)" />
      <circle cx="50" cy="50" r="39" fill="url(#pk-face)" />
      <circle cx="50" cy="50" r="31" fill="none" stroke="var(--brand-1)" strokeOpacity="0.25" strokeWidth="1.5" />
      <g transform="translate(27 36) scale(0.72)" style={{ color: 'var(--brand-1)' }}>
        <path d="M2 32 L22 8 L30 17 L40 4 L62 32 Z" fill="currentColor" />
        <path d="M22 8 L27 14 L24 13 L21 16 L18 13 Z M40 4 L46 12 L42 11 L39 14 L35 10 Z" fill="#fff" />
      </g>
      <ellipse cx="38" cy="26" rx="17" ry="7" fill="#fff" opacity="0.7" transform="rotate(-20 38 26)" />
    </svg>
  );
}
